import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_materia_prima_etapa_ordem_producao = _resolveComponent("materia-prima-etapa-ordem-producao")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_produto_acabado_etapa_ordem_producao = _resolveComponent("produto-acabado-etapa-ordem-producao")!
  const _component_ordem_producao_controle = _resolveComponent("ordem-producao-controle")!
  const _component_ordem_producao_cip = _resolveComponent("ordem-producao-cip")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createBlock(_component_a_tabs, {
    activeKey: _ctx.state.indexSelecionado,
    "onUpdate:activeKey": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.indexSelecionado) = $event))
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedEtapas, (etapa, index) => {
        return (_openBlock(), _createBlock(_component_a_tab_pane, {
          key: index,
          tab: etapa.descricao
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tabs, {
              activeKey: _ctx.computedAbaEtapaAtiva,
              "onUpdate:activeKey": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedAbaEtapaAtiva) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tab_pane, {
                  key: "1",
                  tab: 'Matéria-prima',
                  forceRender: "true"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_materia_prima_etapa_ordem_producao, {
                      materiaPrima: _ctx.computedEtapas[index].materiasPrimas,
                      "onUpdate:materiaPrima": ($event: any) => ((_ctx.computedEtapas[index].materiasPrimas) = $event),
                      codigoEtapa: _ctx.computedEtapas[index].codigo,
                      empresas: _ctx.props.empresas,
                      carregando: true,
                      visivel: true,
                      editavel: _ctx.props.editavel,
                      "editar-apontamento-materia-prima": _ctx.props.editarApontamentoMateriaPrima,
                      "status-ordem-producao": _ctx.props.statusOrdemProducao
                    }, null, 8, ["materiaPrima", "onUpdate:materiaPrima", "codigoEtapa", "empresas", "editavel", "editar-apontamento-materia-prima", "status-ordem-producao"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_a_tab_pane, {
                  key: "2",
                  tab: 'Produto Acabado',
                  forceRender: "true"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_produto_acabado_etapa_ordem_producao, {
                      produtoAcabado: _ctx.computedEtapas[index].produtosAcabados,
                      "onUpdate:produtoAcabado": ($event: any) => ((_ctx.computedEtapas[index].produtosAcabados) = $event),
                      codigoEtapa: _ctx.computedEtapas[index].codigo,
                      empresas: _ctx.props.empresas,
                      carregando: true,
                      "v-model:visivel": true,
                      editavel: _ctx.props.produtoAcabadoEditavel,
                      densidade: _ctx.computedDensidade,
                      "casas-decimais-custo": _ctx.props.casasDecimaisCusto,
                      "codigo-produto-ordem-producao": _ctx.props.codigoProdutoOrdemProducao,
                      criarApontamento: _ctx.computedCriarApontamentoProdutoAcabado,
                      "onUpdate:criarApontamento": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedCriarApontamentoProdutoAcabado) = $event))
                    }, null, 8, ["produtoAcabado", "onUpdate:produtoAcabado", "codigoEtapa", "empresas", "editavel", "densidade", "casas-decimais-custo", "codigo-produto-ordem-producao", "criarApontamento"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_a_tab_pane, {
                  key: "3",
                  tab: 'Controles',
                  forceRender: "true"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ordem_producao_controle, {
                      controles: _ctx.computedControles,
                      "onUpdate:controles": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedControles) = $event)),
                      codigoOrdemProducao: _ctx.props.codigoOrdemProducao,
                      empresas: _ctx.props.empresas,
                      "v-model:visivel": true,
                      editavel: _ctx.props.produtoAcabadoEditavel,
                      "atualizar-controle": _ctx.computedAtualizarControles,
                      "onUpdate:atualizarControle": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedAtualizarControles) = $event))
                    }, null, 8, ["controles", "codigoOrdemProducao", "empresas", "editavel", "atualizar-controle"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "4",
                  tab: 'CIP',
                  forceRender: "true"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ordem_producao_cip, { cips: _ctx.computedCips }, null, 8, ["cips"])
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["activeKey"])
          ]),
          _: 2
        }, 1032, ["tab"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["activeKey"]))
}